import { useTranslation } from '@dreamstack/i18n'
import { Plus } from '@dreamstack/icons/src/icon-components/Plus'
import { RouterOutputs } from '@dreamstack/trpc/client'
import take from 'lodash/take'
import type { FunctionComponent } from 'react'
import { useCallback, useMemo, useRef, useState } from 'react'
import { SimpleMuiButton } from '../layout/SimpleMuiButton'
import { HeadingH3 } from '../layout/Texts'
import { ArticlePreviewGrid } from './ArticlePreviewGrid'

export const LoadMoreNews: FunctionComponent<
  React.PropsWithChildren<{
    articles: RouterOutputs['cms']['getNewsArticlePreviews']['items']
  }>
> = ({ articles }) => {
  const t = useTranslation()
  const paginationSteps = 12
  const [pagination, setPagination] = useState(paginationSteps)

  const loadMore = useCallback(() => {
    setPagination((p) => p + paginationSteps)
  }, [setPagination])
  const ref = useRef(null)

  const paginatedArticles = useMemo(
    () => take(articles, pagination),
    [articles, pagination]
  )

  const showLoadMoreButton = useMemo(() => {
    if (!articles) return false
    return pagination < articles.length
  }, [pagination, articles])

  if (!articles) return null

  return (
    <>
      {!paginatedArticles?.length ? (
        <>
          <div>
            <HeadingH3 className="text-center my-px-160 max-w-[580px] mx-auto">
              {t('accentro:newsHub:articleFilterNoMatchesHeading')}
            </HeadingH3>
          </div>
        </>
      ) : (
        <ArticlePreviewGrid articles={paginatedArticles} />
      )}
      <div
        className="flex justify-center mt-px-40 mb-px-40 md:mt-px-80 md:mb-px-128"
        ref={ref}
      >
        {showLoadMoreButton && (
          <SimpleMuiButton
            onClick={loadMore}
            variant={'outlined'}
            color={'primary'}
            startIcon={<Plus />}
          >
            {t('accentro:newsHub.loadMoreNews')}
          </SimpleMuiButton>
        )}
      </div>
    </>
  )
}
